/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_404_BodyInputs */

const en_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you're looking for doesn't exist.`)
};

const es_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La página que buscas no existe.`)
};

const de_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesuchte Seite existiert nicht.`)
};

const zh_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你要查找的页面不存在。`)
};

const ar_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة التي تبحث عنها غير موجودة.`)
};

const fr_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La page que vous recherchez n'existe pas.`)
};

const vi_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang bạn đang tìm không tồn tại.`)
};

const sw_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukurasa unaotafuta haupo.`)
};

const th_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีหน้าที่คุณกำลังค้นหา`)
};

const bs_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stranica koju tražite ne postoji.`)
};

const ja_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが探しているページは存在しません。`)
};

const ko_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당신이 찾고있는 페이지는 존재하지 않습니다.`)
};

const pt_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A página que você procura não existe.`)
};

const it_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pagina che stai cercando non esiste.`)
};

const sv_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidan du letar efter finns inte.`)
};

const nl_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De pagina die je zoekt bestaat niet.`)
};

const da_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den side, du leder efter, findes ikke.`)
};

const nb_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siden du leter etter eksisterer ikke.`)
};

const fi_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etsimääsi sivua ei ole olemassa.`)
};

const pl_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona, której szukasz nie istnieje.`)
};

const ru_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страницы, которую вы ищете, не существует.`)
};

const tr_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aradığınız sayfa mevcut değil.`)
};

const hi_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जो पृष्ठ आप देख रहे हैं वह मौजूद नहीं है।`)
};

const id_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman yang Anda cari tidak ada.`)
};

const ms_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman yang anda cari tidak wujud.`)
};

const cs_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránka, kterou hledáte, neexistuje.`)
};

const el_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η σελίδα που ψάχνεις δεν υπάρχει.`)
};

const he_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הדף שחיפשתם לא קיים.`)
};

const af_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die bladsy wat jy soek, bestaan nie.`)
};

const hu_error_404_body = /** @type {(inputs: Error_404_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az oldal, amit keresel, nem létezik.`)
};

/**
* | output |
* | --- |
* | "The page you're looking for doesn't exist." |
*
* @param {Error_404_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const error_404_body = /** @type {((inputs?: Error_404_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_404_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_404_body(inputs)
	if (locale === "de") return de_error_404_body(inputs)
	if (locale === "zh") return zh_error_404_body(inputs)
	if (locale === "ar") return ar_error_404_body(inputs)
	if (locale === "fr") return fr_error_404_body(inputs)
	if (locale === "vi") return vi_error_404_body(inputs)
	if (locale === "sw") return sw_error_404_body(inputs)
	if (locale === "th") return th_error_404_body(inputs)
	if (locale === "bs") return bs_error_404_body(inputs)
	if (locale === "ja") return ja_error_404_body(inputs)
	if (locale === "ko") return ko_error_404_body(inputs)
	if (locale === "pt") return pt_error_404_body(inputs)
	if (locale === "it") return it_error_404_body(inputs)
	if (locale === "sv") return sv_error_404_body(inputs)
	if (locale === "nl") return nl_error_404_body(inputs)
	if (locale === "da") return da_error_404_body(inputs)
	if (locale === "nb") return nb_error_404_body(inputs)
	if (locale === "fi") return fi_error_404_body(inputs)
	if (locale === "pl") return pl_error_404_body(inputs)
	if (locale === "ru") return ru_error_404_body(inputs)
	if (locale === "tr") return tr_error_404_body(inputs)
	if (locale === "hi") return hi_error_404_body(inputs)
	if (locale === "id") return id_error_404_body(inputs)
	if (locale === "ms") return ms_error_404_body(inputs)
	if (locale === "cs") return cs_error_404_body(inputs)
	if (locale === "el") return el_error_404_body(inputs)
	if (locale === "he") return he_error_404_body(inputs)
	if (locale === "af") return af_error_404_body(inputs)
	if (locale === "hu") return hu_error_404_body(inputs)
	return en_error_404_body(inputs)
});